import { useState } from 'react';

import RenameModal from '@atom/components/common/RenameModal';
import { Icon, Menu, Modal } from '@atom/mui';
import colors from '@atom/styles/colors';
import { MediaItem } from '@atom/types/media';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import classes from '../formInstance.module.css';

const { MenuItem } = Menu;

interface Props {
  assetId: string;
  media: MediaItem;
  removeFile: (mediaId: string, subjectId: string) => void;
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
}

enum ModalType {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  NONE = 'NONE',
}

interface MediaTitleModal {
  type: ModalType;
  id: any;
}

const FhwaMediaTile = ({ media, assetId, removeFile, renameMedia }: Props) => {
  const [name, setName] = useState<string>(media.name);
  const [openModal, setOpenModal] = useState<MediaTitleModal>({
    type: ModalType.NONE,
    id: null,
  });

  const toggleModal = (modalToOpen: ModalType, mediaId: any) => {
    setOpenModal({ type: modalToOpen, id: mediaId });
  };

  const isModalOpen = (modalType: ModalType, mediaId: any) => {
    const { type, id } = openModal;
    return type === modalType && id === mediaId;
  };

  const renameAction = (id: string, newName: string) => {
    setName(newName);

    renameMedia(id, media.subjectId, newName);
  };

  const { fileExtension, fileId, id, type } = media;

  const onConfirmDeleteModal = () => {
    removeFile(id, assetId);
    toggleModal(ModalType.NONE, null);
  };

  return (
    <>
      <div className={classes.fhwaMediaTileContainer}>
        <div className={classes.fhwaMediaImageContainer}>
          <img
            className={classes.fhwaImage}
            src={`${FILES_ENDPOINT}/${fileId}_180`}
            alt={name}
          />
        </div>
        <div className={classes.fhwaMediaTileInfo}>
          <div
            className={classes.fhwaFileName}
          >{`${name}.${fileExtension}`}</div>
          <Menu>
            <MenuItem
              startAdornment={<Icon>edit</Icon>}
              onClick={() => toggleModal(ModalType.EDIT, id)}
            >
              Edit
            </MenuItem>
            <MenuItem
              startAdornment={<Icon>delete</Icon>}
              onClick={() => toggleModal(ModalType.DELETE, id)}
            >
              Delete
            </MenuItem>
          </Menu>
        </div>
      </div>
      <RenameModal
        open={isModalOpen(ModalType.EDIT, id)}
        closeModal={() => toggleModal(ModalType.NONE, null)}
        id={id}
        name={name}
        type={type}
        renameAction={renameAction}
      />
      <Modal
        open={isModalOpen(ModalType.DELETE, id)}
        onCancel={() => toggleModal(ModalType.NONE, null)}
        title={`Delete ${name}`}
        confirmButtonText="Delete"
        ConfirmButtonProps={{ sx: { background: colors.brand.red } }}
        onConfirm={onConfirmDeleteModal}
      >
        Are you sure you want to delete this photo?
      </Modal>
    </>
  );
};

export default FhwaMediaTile;
